// extracted by mini-css-extract-plugin
export default {"container":"CodeBlock_container__zjvNc","code":"CodeBlock_code__r84nK"};